module.exports = __webpack_public_path__ + "static/img/pic_cusi@2x.8752d7e9.png";